export default __webpack_public_path__ + "static/media/leg-right-back.a2beb656.png";